import React, { useEffect, useRef, useState } from "react";
import { Navigation } from "./navigation";
import { SecondSection } from "./secondSection";
import { Footer } from "./Footer";
import TestSeriesSection, { SectionTestSeries } from "./SectionTestSeries";
import HomeSection2 from "./homepage/RatingSection";
import FacultySection from "./homepage/FacultyList";
import instId from "./network/instituteId";
import Endpoints, { BASE_URL } from "./network/endpoints";
import axios from "axios";
import { ReelsSection } from "./ReelsSection";
import IframFormSection from "./homepage/IframeSection";
import FaQqSection from "./homepage/FaqSection";
import { useLocation } from "react-router-dom";
import { TestSeriesCard } from "./homepage/TestSeriesCard";
import ExamPrepSection from "./homepage/ExamPrep";
import { ClassRoomCourses } from "./ClassRoomTestSeriesCourse";
import { GallerySection } from "./GellerySection";


const Home = () => {

  const testSeries = useRef(null);
  const iframeFormRef = useRef(null);
  const location = useLocation();
  const [endpointsUrl, setEndpointsUrl] = useState('')
  const [instituteRes, setInstituteRes] = useState('')

  useEffect(() => {
    window.scrollTo(0, 0);
    getInstituteDetail();
    if (window.location.hash === "#downloadOurApp") {
      testSeries.current?.scrollIntoView({ behavior: "smooth" });
    }
  }, []);

  useEffect(() => {
    if (location.state?.scrollTo === "contact") {
      setTimeout(() => {
        iframeFormRef.current?.scrollIntoView({ behavior: "smooth" });
      }, 100);
    }
  }, [location]);

  const getInstituteDetail = async () => {
    try {
      let requestOptions = {
        // headers: { "X-Auth": token },
        withCredentials: false,
      };
      const response = await axios.get(
        BASE_URL + "/getMetaData/fetch-institute/" + instId,
        requestOptions
      );
      if (response?.data?.errorCode === 0) {

        setInstituteRes(response?.data?.institute)
        setEndpointsUrl(response?.data?.instituteTechSetting?.mediaUrl)
        Endpoints.mediaBaseUrl = response?.data?.instituteTechSetting?.mediaUrl
      };
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div>
      <SecondSection endpointsUrl={endpointsUrl} />
      <HomeSection2 endpointsUrl={endpointsUrl} />
      <ExamPrepSection endpointsUrl={endpointsUrl} testSeries={testSeries} />
      {/* <TestSeriesCard endpointsUrl={endpointsUrl} /> */}
      <ReelsSection endpointsUrl={endpointsUrl} />
      {/* <div ref={iframeFormRef}>
      <IframFormSection endpointsUrl={endpointsUrl} />
      </div> */}
      <div ref={testSeries}>
        <TestSeriesSection endpointsUrl={endpointsUrl} />
      </div>
      <FacultySection endpointsUrl={endpointsUrl} />
      <GallerySection instituteRes={instituteRes} endpointsUrl={endpointsUrl} />
      <ClassRoomCourses endpointsUrl={endpointsUrl} />
      <FaQqSection endpointsUrl={endpointsUrl} />
    </div>
  )
};

export default Home;